export default {
  INVESTOR_PROFILE_REPOSITORY: Symbol.for('INVESTOR_PROFILE_REPOSITORY'),
  GET_INVESTOR_PROFILE_QUERY: Symbol.for('GET_INVESTOR_PROFILE_QUERY'),
  UPDATE_INVESTOR_PROFILE_COMMAND: Symbol.for('UPDATE_INVESTOR_PROFILE_COMMAND'),
  INVESTOR_PROFILE_STATE_MANAGER: Symbol.for('INVESTOR_PROFILE_STATE_MANAGER'),
};
